import React,{Component} from "react";
// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button,
  Table,
  Modal,
  ModalBody,ModalFooter
} from "reactstrap";
import { Redirect } from "react-router-dom";
import ReactHtmlParser from 'react-html-parser';
// core components
import logo from "components/ptelogo.png";
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import API, {base} from "api.js";
import {store,persistor} from 'store/index';
import Unauthorized from "components/Exceptions/Unauthorized";

class Result extends Component {
  constructor(props) {
    super(props);
    this.state = {
      result:{},
      com:[],
      enable:[],
      factor:[],
      total:0,
      time:0,
      score_text:"",
      subdomain:false,
      subdomainLogo:"",
      unauthorized: false,
      isLoaded: false,
    };
  }
  componentDidMount() {
    let subdomain = window.location.hostname.split('.').shift();
    if (subdomain !== 'www') {
      this.setState({subdomain:true});
      var bodyFormData = new FormData();
      bodyFormData.set('subdomain', window.location.hostname.split('.').shift());
      API({
        method: 'POST',
        url: 'get-logo',
        data:bodyFormData
      }).then(data => {
        if (data.data.response.data) {
          this.setState({subdomain: true});
          this.setState({subdomainLogo: data.data.response.data});
        }
      }).catch(()=>{
        this.setState({subdomain:false});
        window.location.href = "https://www.20task.com/";
      });
    }
    document.body.classList.toggle("sidebar-mini");
    //document.querySelector('#minimizeSidebar').style.display = "none"
    API({
        method: 'GET',
        url: `/mock/score/${this.props.match.params.id}`
      }).then(data => {
       const dt = data.data.data;
       console.log('------hello', data);
       this.setState({ isLoaded: true });
       if(
          typeof data.data.message !== 'undefined' && 
          typeof data.data.message !== undefined && 
          data.data.message === 'unauthorized access'
        ) {
          this.setState({unauthorized: true});
        }

       this.setState({
         score_text: dt.text,
         factor: dt.factor,
         com: dt.com,
         enable: dt.enable,
         total: dt.total,
         time: dt.time.split("T")[0]
       });
    }).catch(()=>{

    });
  }

  componentWillUnmount() {
    document.body.classList.toggle("sidebar-mini");
    //document.querySelector('#minimizeSidebar').style.display = "block"
  }
  showScore = (e,id) =>{
    this.setState({modal:!this.state.modal,id:id});
  }
  render() {

    let { total, com, score_text } = this.state;
    
    let new_listening = com.listening;
    let new_reading = com.reading;
    let new_writing = com.writting;
    let new_speaking = (com.speaking - 5) >= 10 ? (com.speaking - 5) : 10;
    let new_total = total;

    if (score_text.includes('Speaking') || score_text.includes('Overall')) {
      new_total = (total - 5) >= 10 ? (total - 5) : 10;
    }
    
    return (
      <>
      { !this.state.isLoaded ? (
      <></>
      ) : ( <>
      { !this.state.unauthorized ? ( <>
      <div className="content questionsArea">
          {false && <div className="row">
                  <div className="col-sm-12">
                    <ul class="connectList">
                      <li class="cross" ><span>1. When you stress them, they experience damage, which is a good thing.</span></li>
                      <li class="cross"><span>1. When you stress them, they experience damage, which is a good thing.</span></li>
                      <li class="cross"><span>1. When you stress them, they experience damage, which is a good thing.</span></li>
                      <li class="cross"><span>1. When you stress them, they experience damage, which is a good thing.</span></li>
                      <li ><span>1. When you stress them, they experience damage, which is a good thing.</span></li>
                    </ul>
                  </div>
                </div>}
          <Row>
            <Col xs={12}>
              <Card>
                <CardHeader>
                  <Row>
                    <Col xs={6}>
                      <CardTitle tag="h4">
                      </CardTitle>
                    </Col>
                    <Col xs={6}>
                      <div className="text-right questionTime">
                      </div>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Row className='unselectable'>
                  <div class="container">
                    {store.getState().is_main && <div className="scoreHeader mb-5 row">
                                          <div className={this.state.subdomainLogo ? 'col-md-12' : 'col-md-7' }>
                                            <img src={logo} alt="ptelogo" />
                                            {this.state.subdomainLogo ? <img src={base+this.state.subdomainLogo} alt="ptesubdmomainlogo" class="float-right"/> : '' }
                                            <span className="">Score Report Code: <samp>{new_total}</samp></span>
                                          </div>
                                          <div className={this.state.subdomainLogo ? 'col-md-12 scoreFooter' : 'col-md-5 scoreFooter' }>
                                            <div class="call"><i class="fa fa-envelope" aria-hidden="true"></i> <a href="mailto:info@20task.com">info@20task.com</a></div>
                                            <div class="website"><i class="fa fa-globe" aria-hidden="true"></i> <a href="https://www.20task.com">www.20task.com</a></div>
                                          </div>
                                        </div>}

                    <div className="scorecard row mb-5">
                      <div className="col scoreUserImg">
                        <div className="scoreImgOuter">
                          <img src={(store.getState().user.image)?base+store.getState().user.image:"data:image/jpeg;base64,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"} alt="Avatar" />
                        </div>
                      </div>
                      <div class="col scoreBlock">
                        <h3>{store.getState().user.first_name} {store.getState().user.last_name}</h3>
                        <p>Communicative Skills</p>
                        <div class="row text-center">
                          {this.state.com.hasOwnProperty('listening') && <div class="col listening"><div class="scoreNumber">{new_listening}</div><span>Listening</span></div>}
                          {this.state.com.hasOwnProperty('reading') && <div class="col reading"><div class="scoreNumber">{new_reading}</div><span>Reading</span></div>}
                          {this.state.com.hasOwnProperty('speaking') && <div class="col speaking"><div class="scoreNumber">{new_speaking}</div><span>Speaking</span></div>}
                          {this.state.com.hasOwnProperty('writting') && <div class="col writing"><div class="scoreNumber">{new_writing}</div><span>Writing</span></div>}
                        </div>
                      </div>
                      <div class="col overallScore">
                        <div class="overallScoreInr">
                          <span>{this.state.score_text}</span><samp>{new_total}</samp></div>
                        </div>
                    </div>

                    {store.getState().is_main && <div class="row comucationSkills mb-5">
                                          <div class="col-sm-12">
                                            <div class="languageLogo">
                                              <img src={logo} alt="ptelogo" />
                                            </div>
                                          </div>
                                        </div>}

                    <div class="row skillsBreakdown mb-5">
                      <div class="col-sm-7">
                        <h3>Skills Breakdown</h3>
                        <div class="skilsNscore">
                          {this.state.total && <div class="overallBar">
                              <span>
                                <samp class="bar" style={{left:(new_total)+'%'}}></samp>
                                <samp class="score" style={{left:(new_total)+'%'}}>{new_total} Overall</samp>
                              </span>
                            </div>}
                          <ul>
                            {this.state.com.hasOwnProperty('listening') && <li class="listening">
                              <label>Listening <i class="fa fa-info-circle" title={"out of "+(this.state.factor['listen']+10)} aria-hidden="true"></i></label>
                              <div class="numberBar">
                                <span class="number">{new_listening}</span><div class="bar"><samp style={{width:(new_listening)+'%'}}></samp></div>
                              </div>
                            </li>}
                            {this.state.com.hasOwnProperty('reading') && <li class="reading">
                              <label>Reading <i class="fa fa-info-circle" title={"out of "+(this.state.factor['read']+10)} aria-hidden="true"></i></label>
                              <div class="numberBar">
                                <span class="number">{new_reading}</span><div class="bar"><samp style={{width:(new_reading)+'%'}}></samp></div>
                              </div>
                            </li>}
                            {this.state.com.hasOwnProperty('speaking') && <li class="speaking">
                              <label>Speaking <i class="fa fa-info-circle" aria-hidden="true" title={"out of "+(this.state.factor['speak']+10)}></i></label>
                              <div class="numberBar">
                                <span class="number">{new_speaking}</span><div class="bar"><samp style={{width:(new_speaking)+'%'}}></samp></div>
                              </div>
                            </li>}
                            {this.state.com.hasOwnProperty('writting') && <li class="writing">
                              <label>Writing <i class="fa fa-info-circle" aria-hidden="true" title={"out of "+(this.state.factor['write']+10)}></i></label>
                              <div class="numberBar">
                                <span class="number">{new_writing}</span><div class="bar"><samp style={{width:(new_writing)+'%'}}></samp></div>
                              </div>
                            </li>}
                          </ul>
                          {/* <h4><span>Enabling Skills</span></h4>
                          <ul>
                            {this.state.enable.hasOwnProperty('grammar') && <li>
                              <label>Grammar <i class="fa fa-info-circle" title={"out of 90"} aria-hidden="true"></i></label>
                              <div class="numberBar">
                                <span class="number">{this.state.enable.grammar}</span><div class="bar"><samp style={{width:(this.state.enable.grammar)+'%'}}></samp></div>
                              </div>
                            </li>}
                            {this.state.enable.hasOwnProperty('fluency') && <li>
                              <label>Oral Fluency <i class="fa fa-info-circle" title={"out of 90"} aria-hidden="true"></i></label>
                              <div class="numberBar">
                                <span class="number">{this.state.enable.fluency}</span><div class="bar"><samp style={{width:(this.state.enable.fluency)+'%'}}></samp></div>
                              </div>
                            </li>}
                            {this.state.enable.hasOwnProperty('pronunciation') && <li>
                              <label>Pronunciation <i class="fa fa-info-circle" title={"out of 90"} aria-hidden="true"></i></label>
                              <div class="numberBar">
                                <span class="number">{this.state.enable.pronunciation}</span><div class="bar"><samp style={{width:(this.state.enable.pronunciation)+'%'}}></samp></div>
                              </div>
                            </li>}
                            {this.state.enable.hasOwnProperty('spelling') && <li>
                              <label>Spelling <i class="fa fa-info-circle" title={"out of 90"} aria-hidden="true"></i></label>
                              <div class="numberBar">
                                <span class="number">{this.state.enable.spelling}</span><div class="bar"><samp style={{width:(this.state.enable.spelling)+'%'}}></samp></div>
                              </div>
                            </li>}
                            {this.state.enable.hasOwnProperty('vocab') && <li>
                              <label>Vocabulary <i class="fa fa-info-circle" title={"out of 90"} aria-hidden="true"></i></label>
                              <div class="numberBar">
                                <span class="number">{this.state.enable.vocab}</span><div class="bar"><samp style={{width:(this.state.enable.vocab)+'%'}}></samp></div>
                              </div>
                            </li>}
                            {this.state.enable.hasOwnProperty('discourse') && <li>
                              <label>Written Discourse <i class="fa fa-info-circle" title={"out of 90"} aria-hidden="true"></i></label>
                              <div class="numberBar">
                                <span class="number">{this.state.enable.discourse}</span><div class="bar"><samp style={{width:(this.state.enable.discourse)+'%'}}></samp></div>
                              </div>
                            </li>}
                          </ul> */}
                        </div>
                      </div>
                      <div class="col-sm-5 infoBlock">
                        <h3>Candidate Information</h3>
                        <div class="infoOuter">
                          <p><b>Date of Birth: </b>{store.getState().user.dob}</p>
                          <p><b>Country of Citizenship: </b>{store.getState().user.country_citizenship}</p>
                          <p><b>Country of Residence: </b>{store.getState().user.country_residence}</p>
                          <p><b>Email: </b>{store.getState().user.email}</p>
                          <p><b>First-Time Test Taker: </b>No</p>
                        </div>
                        {/* <h3 class="pb-1 mb-2">Test Center Information</h3>
                        <div class="infoOuter">
                          <p><b>Test Date: </b>{this.state.time}</p>
                          <p><b>Valid Until: </b>{this.state.time}</p>
                          <p><b>Report issue date: </b>{this.state.time}</p>
                          <p><b>Test Center Country: </b>{store.getState().user.country_residence}</p>
                          <p><b>Test Centre ID: </b>LanguageAcademy</p>
                          <p><b>Test Centre: </b>online</p>
                        </div> */}
                      </div>
                    </div>
                    <div class="row skillsBreakdown mb-5">
                      <h3 class="pb-4 mb-4 col-sm-12">Test Center Information</h3>
                      <p className="col-sm-7"><b>Test Date: </b>{this.state.time}</p>
                      <p className="col-sm-5"><b>Valid Until: </b>{this.state.time}</p>
                      <p className="col-sm-7"><b>Report issue date: </b>{this.state.time}</p>
                      <p className="col-sm-5"><b>Test Center Country: </b>{store.getState().user.country_residence}</p>
                      <p className="col-sm-7"><b>Test Centre ID: </b>20Task</p>
                      <p className="col-sm-5"><b>Test Centre: </b>online</p>
                    </div>
                    {store.getState().is_main && <div class="scoreFooter">
                                          <span class="call"><i class="fa fa-envelope" aria-hidden="true"></i> <a href="mailto:info@20task.com">info@20task.com</a></span>
                                          <span class="website"><i class="fa fa-globe" aria-hidden="true"></i> <a href="https://>www.20task.com/">www.20task.com</a></span>
                                        </div>}
                      <small><b>This scorecard is not an official scorecard and cannot be used for any official purposes. The overall score in this mock test will give you the closest idea of how much you will score in the real exam but doesn’t represent the exact score you will achieve in the exam.</b></small>
                      <br/>{this.state.score_text != "Overall Score" && <small>Please note that this overall score is calculated based on how you performed in this particular section. In the full mock test or real exam, your sectional score is calculated by combining the transferable scores with the sectional scores. For example, your writing score is calculated as a sum of the Writing section, Reading and Writing Blanks, Summarise Spoken Text, Listening Fill in the Blanks, and Write from Dictation. Therefore, in the exam or full mock test, your score may vary depending on your performance in the other sections.</small>}
                    </div>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        </>) : <Unauthorized /> }
        </>
      )}
      </>
    );
  }
}
export default Result;
